import {
	createBrowserRouter,
	createRoutesFromElements,
	RouterProvider,
	Route,
} from "react-router-dom";
import PlansTemplate from "./pages/PlansTemplate";
import DetailAgency from "./pages/agencies/DetailAgency";
import PlanDetail from "./pages/plan/PlanDetail";
import PlanTemplateContainer from "./pages/plan/PlanTemplateContainer";
import ListAgencies from "./pages/agencies/ListAgencies";
import PlanConfPreview from "./pages/plan/PlanConfPreview";
import {
	checkPlanTemplate,
	getPlanTemplate,
	loaderCopyTemplate,
	loaderEntityDetail,
	loaderEntityPlan,
	loaderCompilePlan,
	loaderListAgenda,
	loaderAgendaDetail,
	redirectUser,
	checkAdmin,
	checkReseller,
	checkOrganization,
	onganizationDetail,
	checkSession,
	loaderOrganizationPlan,
	loaderOrganizationCompile,
	templatePlanPresetsLoader,
	organizationPlanPresetsLoader,
	loaderTemplatesPlansContentPresetEditor,
} from "./helper/loader.helper";
import PageContainer from "./pages/PageContainer";
import PlanCopyConfContainer from "./pages/plan/PlanCopyConfContainer";
import PlanCompileContainer from "./pages/plan/PlanCompileContainer";
import PlanContentPresetsCompileContainer from "./pages/plan/PlanContentPresetsCompileContainer";
import PlanContentPresetsCopyContainer from "./pages/plan/PlanContentPresetsCopyContainer";
import ListAgendas from "./pages/agenda/ListAgendas";
import AgendaDetail from "./pages/agenda/AgendaDetail";
import Custom404 from "./pages/Custom404";
import HomeRedirect from "./pages/HomeRedirect";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import PlanPresetsPage from "./pages/plan/PlanPresetsPage";
dayjs.extend(utc);

const router = createBrowserRouter(
	createRoutesFromElements(
		<>
			<Route
				path="/"
				loader={redirectUser}
				element={<HomeRedirect />}
				errorElement={<Custom404 />}
			/>
			{/*<Route
        path="/auth-session/:sessionToken"
        loader={authSession}
        element={<RedirectToken />}
      />*/}
			<Route
				path="/"
				loader={checkSession}
				errorElement={<Custom404 />}
				element={<PageContainer />}
			>
				{/* Admin */}
				<Route path="admin" loader={checkAdmin}>
					<Route path="plans" element={<PlansTemplate />} />
					{/* Plan Template */}
					<Route
						path="plans/template/detail/:id"
						loader={getPlanTemplate}
						element={<PlanConfPreview />}
					/>

					<Route
						path="plans/template/configuration/:id"
						loader={checkPlanTemplate}
						element={<PlanTemplateContainer isAdmin />}
					/>

					<Route
						path="plans/template/:id/presets"
						loader={templatePlanPresetsLoader}
						element={<PlanPresetsPage />}
					/>

					<Route
						path="plans/template/copy/:idCorp/:idPlan"
						loader={loaderCopyTemplate}
						element={<PlanCopyConfContainer />}
					/>

					<Route
						path="plans/templates/:templatePlan/content-presets/:contentPreset/compile"
						loader={loaderTemplatesPlansContentPresetEditor}
						element={<PlanContentPresetsCompileContainer />}
					/>

					<Route
						path="plans/templates/:templatePlan/content-presets/:contentPreset/copy"
						loader={loaderTemplatesPlansContentPresetEditor}
						element={<PlanContentPresetsCopyContainer />}
					/>

					<Route
						path="plans/templates/:templatePlan/content-presets/:contentPreset/copy/:idOrganization/:idOrganizationPlan"
						loader={loaderTemplatesPlansContentPresetEditor}
						element={<PlanContentPresetsCopyContainer />}
					/>

					{/* Entities */}
					<Route path="entities" element={<ListAgencies />} />
					<Route
						path="entities/entity/:id"
						loader={loaderEntityDetail}
						element={<DetailAgency />}
					/>
					<Route
						path="entities/entity/:id/plan/:idPlan"
						loader={loaderEntityPlan}
						element={<PlanDetail />}
					/>

					<Route
						path="entities/entity/:id/plan/:idPlan/compile"
						loader={loaderCompilePlan}
						element={<PlanCompileContainer />}
					/>

					{/* Diary */}
					<Route
						path="agendas"
						loader={loaderListAgenda}
						element={<ListAgendas userRole="admin" />}
					/>
					<Route
						path="agendas/:idCorp/:id"
						loader={loaderAgendaDetail}
						element={<AgendaDetail userRole="admin" />}
					/>
				</Route>

				{/* Reseller */}
				<Route path="reseller" loader={checkReseller}>
					<Route index element={<ListAgencies isReseller={true} />} />

					<Route
						path="presets/:id/:idPlan"
						loader={organizationPlanPresetsLoader}
						element={<PlanPresetsPage />}
					/>

					<Route
						path=":id"
						loader={loaderEntityDetail}
						element={<DetailAgency userRole="reseller" />}
					/>
					<Route
						path=":id/plan/:idPlan"
						loader={loaderEntityPlan}
						element={<PlanDetail userRole="reseller" />}
					/>
					<Route
						path=":id/plan/:idPlan/compile"
						loader={loaderCompilePlan}
						element={<PlanCompileContainer userRole="reseller" />}
					/>

					<Route
						path="agendas"
						loader={loaderListAgenda}
						element={<ListAgendas userRole="reseller" />}
					/>
					<Route
						path="agendas/:idCorp/:id"
						loader={loaderAgendaDetail}
						element={<AgendaDetail userRole="reseller" />}
					/>
				</Route>

				{/* Organization */}
				<Route path="organization" loader={checkOrganization}>
					<Route
						index
						loader={onganizationDetail}
						element={<DetailAgency userRole="organization" />}
					/>
					<Route
						path="plan/:idPlan"
						loader={loaderOrganizationPlan}
						element={<PlanDetail userRole="organization" />}
					/>
					<Route
						path="plan/:idPlan/compile"
						loader={loaderOrganizationCompile}
						element={<PlanCompileContainer userRole="organization" />}
					/>

					<Route
						path="agendas"
						loader={loaderListAgenda}
						element={<ListAgendas userRole="organization" />}
					/>

					<Route
						path="agendas/:idCorp/:id"
						loader={loaderAgendaDetail}
						element={<AgendaDetail userRole="organization" />}
					/>
				</Route>
			</Route>
		</>
	)
);

function App() {
	return (
		<>
			<RouterProvider router={router} />
			{process.env.REACT_APP_DEV_BANNER_LABEL && (
				<div className="fixed h-[20px] bg-red-100 w-full top-0 left-0 z-[99999] text-white font-semibold text-center uppercase text-xs leading-[1.5em]">
					{process.env.REACT_APP_DEV_BANNER_LABEL}
				</div>
			)}
		</>
	);
}

export default App;
